import React from "react";
import Slider from "react-slick";
import { Link, ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import { ImageFallback } from "./image-fallback.js";
import get from "lodash/get";
import { altTagOfHeroImages} from "../../utils";


function SimpleSlider(props) {
  const settings = {
      dots: false,
      infinite: props.stories.length > 1,
      speed: 600,
      arrows: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      rtl: get(props.config, ['theme-attributes', 'language_direction']) === 'right',
    };
  return !props.stories ? null : <div className="simple-slider">
      <Slider {...settings}>
        {props.stories.map((item) =>
          <div key={item.id}>
            <SliderItem item={item} heading={props.heading} />
          </div>
        )}
      </Slider>
    </div>
}

function SliderItem(props) {
  {/* The `story` can be an item from items of a collection or a story itself.
   assigning it accordinlgy.*/}
  const story = props.item && props.item.type === 'story' && props.item.story ? props.item.story : props.item;
  const isReviewStory = story["story-template"] === 'review';
  return (
    <div className="simple-slider__item">
      { story["hero-image-s3-key"] ?
      <figure className={`${story['story-template'] === "video" ? "simple-slider__image__video" : ""}`}>
        <ResponsiveHeroImage story={story}
          aspectRatio={[9,3]}
          alt={altTagOfHeroImages(story)}
          defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
          imgParams={{auto:['format', 'compress'], fit:'max'}}/>
      </figure> :
      <ImageFallback bgColor='#adc1d6'/> }
      <div className="simple-slider__content">
        <p className="simple-slider__section-name">{props.heading}</p>
        <h2 className="simple-slider__story-heading"><bdi dangerouslySetInnerHTML={{__html:story.headline}}></bdi></h2>
        {isReviewStory && <ReviewRating value={get(story, ['metadata','review-rating', 'value'], '0')} />}
        <Link href={"/" + story.slug } className="simple-slider__link" >
          read story
        </Link>
      </div>
    </div>
  )
}

export { SimpleSlider }
